import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-invoice-receipt',
  templateUrl: './invoice-receipt.component.html',
  styleUrls: ['./invoice-receipt.component.scss']
})
export class InvoiceReceiptComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
